import React, { useMemo } from 'react';
import { formatGemeenschapLabel } from '../services/conviventieLabels';
import './EditConviventieModal.css';

const EditConviventieModal = ({
  isOpen,
  isEditMode,
  formData,
  onChange,
  onToggleGemeenschap,
  onToggleGuestGroup,
  onCreateGuestGroup,
  availableGemeenschappen,
  availableGuestGroups,
  onSubmit,
  onClose
}) => {
  const selectedGemeenschapIds = useMemo(
    () => new Set((formData.uitgenodigdeGemeenschapIds || [])),
    [formData.uitgenodigdeGemeenschapIds]
  );
  const selectedGuestGroupIds = useMemo(
    () => new Set((formData.invitedGuestGroupIds || [])),
    [formData.invitedGuestGroupIds]
  );

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{isEditMode ? 'Conviventie bewerken' : 'Nieuwe Conviventie'}</h3>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>

        <form className="modal-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="naam">Naam</label>
              <input id="naam" name="naam" value={formData.naam} onChange={onChange} required />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="datum">Start datum</label>
              <input id="datum" type="date" name="datum" value={formData.datum} onChange={onChange} required />
            </div>
            <div className="form-group">
              <label htmlFor="eindDatum">Eind datum</label>
              <input
                id="eindDatum"
                type="date"
                name="eindDatum"
                value={formData.eindDatum}
                onChange={onChange}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="locatie">Locatie</label>
            <input id="locatie" name="locatie" value={formData.locatie} onChange={onChange} />
          </div>

          <div className="form-group">
            <label htmlFor="opmerkingen">Opmerkingen</label>
            <textarea id="opmerkingen" name="opmerkingen" rows="3" value={formData.opmerkingen} onChange={onChange} />
          </div>

          <div className="form-group">
            <label>Uitgenodigde gemeenschappen</label>
            <div className="checkbox-grid">
              {availableGemeenschappen.map((item) => {
                return (
                  <div key={item.id} className="checkbox-row">
                    <input
                      id={`uitgenodigde-${item.id}`}
                      className="community-checkbox"
                      type="checkbox"
                      checked={selectedGemeenschapIds.has(item.id)}
                      onChange={() => onToggleGemeenschap(item.id)}
                    />
                    <label htmlFor={`uitgenodigde-${item.id}`} className="checkbox-option">
                      <div className="checkbox-option-main">
                        <div className="community-meta-chips">
                          <span className="community-chip">{item.bisdom || '-'}</span>
                        </div>
                        <div className="community-name">{formatGemeenschapLabel(item)}</div>
                      </div>
                    </label>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="form-group">
            <label>Gastengroepen om extra genodigden te beheren (optioneel)</label>

            <div className="checkbox-grid guest-group-grid">
              {availableGuestGroups.length === 0 ? (
                <p className="guest-group-empty">Nog geen bestaande gastengroepen</p>
              ) : (
                availableGuestGroups.map((group) => (
                  <div key={group.id} className="checkbox-row">
                    <input
                      id={`guest-group-${group.id}`}
                      className="community-checkbox"
                      type="checkbox"
                      checked={selectedGuestGroupIds.has(group.id)}
                      onChange={() => onToggleGuestGroup(group.id)}
                    />
                    <label htmlFor={`guest-group-${group.id}`} className="checkbox-option">
                      <div className="checkbox-option-main">
                        <div className="community-name">{group.name || '-'}</div>
                      </div>
                    </label>
                  </div>
                ))
              )}
            </div>

            <label>of maak een nieuwe gastengroep aan voor deze conviventie</label>

            <div className="guest-group-create-row">
              <button
                type="button"
                className="button button-secondary"
                onClick={onCreateGuestGroup}
              >
                New gastengroup
              </button>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="button button-secondary" onClick={onClose}>Annuleren</button>
            <button type="submit" className="button button-primary">
              {isEditMode ? 'Opslaan' : 'Toevoegen'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditConviventieModal;
